import { IconSpinner } from '@assets/icon-spinner';

export const Spinner = ({ iconSize = '24px' }) => {
  return <IconSpinner iconSize={iconSize} classProps={{ root: 'origin-center animate-spin' }} />;
};
